import { render, staticRenderFns } from "./MyComments.vue?vue&type=template&id=783c4915&"
import script from "./MyComments.vue?vue&type=script&lang=js&"
export * from "./MyComments.vue?vue&type=script&lang=js&"
import style0 from "./MyComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports